<template>
  <div>
  <h1>Perfil</h1>

  <v-layout row justify-center>
      <v-flex xs12 sm6 md6 lg4>
        <v-card class="card-main">
          <v-card-title primary-title>
            <v-card-text>
              <v-container grid-list-md text-xs-center>
                <v-layout row wrap>
                  <v-flex xs12>

                    <v-form v-model="valid" ref="form" lazy-validation>
                      <v-flex xs12 sm12>
                        <v-text-field
                          class="username"
                          label="E-Mail/Usuário"
                          v-model="user.username"
                          :counter="40"
                          :rules="[v => !!v || 'E-mail obrigatório!!']" required
                          prepend-icon="email"
                          disabled
                        ></v-text-field>
                        <v-text-field
                          disabled
                          label="Nome"
                          v-model="user.name"
                          :counter="40"
                          required
                          class="name"
                        ></v-text-field>
                        <v-text-field
                          disabled
                          label="Ficha"
                          v-model="user.numberMedicalRecord"
                          required
                          class="name"
                        ></v-text-field>
                        <v-radio-group v-model="user.gender" row class="gender" disabled>
                          <v-radio label="Masculino" value="M" color="blue" disabled></v-radio>
                          <v-radio label="Feminino" value="F" color="red" disabled></v-radio>
                        </v-radio-group>
                        <v-text-field
                          disabled
                          label="CPF"
                          v-model="user.cpf"
                          :rules="[v => !!v || 'CPf obrigatório!!']" required
                          mask="###.###.###-##"
                          class="cpf"
                        ></v-text-field>
                        <v-text-field
                          disabled
                          label="Data Nasc."
                          mask="date"
                          v-validate="'date_format:DD-MM-YYYY'"
                          v-model="user.birthDay"
                          :error-messages="errors.collect('name')"
                          data-vv-name="birthday"
                          :rules="[v => !!v || 'Data de Nasc. obrigatória!!']" required
                          class="birthDay"
                        ></v-text-field>
                        <v-select
                          class="healthInsurance"
                          ref="healthInsurance"
                          item-text="name"
                          item-value="id"
                          label="Convênio"
                          v-model="user.healthInsurance"
                          :items="healthInsurances"
                          :rules="[v => !!v || 'Convênio obrigatório!!']" required
                        ></v-select>
                        <!-- Retirado o autcomplete -->
                        <!-- <v-select
                          class="healthInsurance"
                          ref="healthInsurance"
                          item-text="name"
                          item-value="id"
                          label="Convênio"
                          v-model="user.healthInsurance"
                          :items="healthInsurances"
                          :rules="[v => !!v || 'Convênio obrigatório!!']" required
                          autocomplete
                        ></v-select> -->
                        <v-text-field
                          class="mobile"
                          label="Fone Fixo"
                          mask="(##) ####-#####"
                          v-model="user.phone"
                          prepend-icon="phone"
                        ></v-text-field>
                        <v-text-field
                          class="mobile"
                          label="Celular"
                          mask="(##)# ####-####"
                          v-model="user.mobile"
                          prepend-icon="phone"
                          :rules="[v => !!v || 'Você deve informar um número de celular!']" required
                        ></v-text-field>
                      </v-flex>
                    <div class="buttons">
                      <v-btn
                        color = 'primary'
                        @click="submit"
                        :disabled="!valid"
                      >
                        Atualizar
                      </v-btn>
                      <router-link to="/">
                        <v-btn>Voltar</v-btn>
                      </router-link>
                    </div>
                  </v-form>
                </v-flex>
              </v-layout>
              </v-container>
            </v-card-text>
          </v-card-title>
          <v-card-actions>
            <div>© 2017 - {{ new Date().getFullYear() }} <a href="http://www.spitzer.io">Spitzer.io</a> - Todos os direitos reservados</div>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-snackbar
      :timeout="snackbarConfig.timeout"
      :color="snackbarConfig.color"
      :multi-line="snackbarConfig.mode === 'multi-line'"
      :vertical="snackbarConfig.mode === 'vertical'"
      v-model="snackbarConfig.snackbar"
    >
      {{ snackbarConfig.text }}
      <v-btn dark flat @click.native="snackbarConfig.snackbar = false">Fechar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    methods: {
      ...mapActions(['setUser']),
      submit () {
        this.$validator.validateAll()
        this.user.birthDay = moment(this.auth.user.profile.birthDay).format('MM-DD-YYYY')
        this.$http.post(process.env.URL + '/schedule-online/auth/patient/update', this.user, {
          params: {
            customer: this.customer
          }
        }).then((response) => {
          const aaa = response.data.result.user
          console.log(aaa)
          const auth = {
            isLogged: true,
            token: response.data.result.token,
            user: {
              username: this.auth.user.username,
              id: response.data.result.result[0]._id,
              customer: this.customer,
              name: response.data.result.result[0].name,
              healthInsurance: this.user.healthInsurance,
              numberMedicalRecord: response.data.result.user.numberMedicalRecord,
              profile: response.data.result.result[0].profile
            }
          }
          this.setUser(auth)
          this.snackbarConfig.snackbar = true
          this.snackbarConfig.text = 'Dados atualizados!'
        })
      },
      loadHealthInsurance () {
        this.$http.get(process.env.URL + '/schedule-online/health-insurance', {
          params: {
            customer: this.customer
          }
        }).then((healthInsurance) => {
          console.log(this.auth.user.healthInsurance)
          this.healthInsurances = healthInsurance.data.result
          this.user.healthInsurance = this.auth.user.healthInsurance
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    mounted () {
      this.loadHealthInsurance()
      this.user.id = this.auth.user.id
      this.user.name = this.auth.user.name
      this.user.numberMedicalRecord = this.auth.user.numberMedicalRecord
      this.user.username = this.auth.user.username
      this.user.birthDay = moment(this.auth.user.profile.birthDay, 'MM/DD/YYYY').format('DD/MM/YYYY')
      this.user.cpf = this.auth.user.profile.cpf
      this.user.healthInsurance = this.auth.user.healthInsurance
      this.user.phone = this.auth.user.profile.phone
      this.user.mobile = this.auth.user.profile.mobile
      this.user.clientId = this.auth.user.clientId
      this.user.gender = this.auth.user.profile.gender
    },
    computed: {
      ...mapGetters({
        customer: 'customer',
        auth: 'auth'
      }),
      ...mapGetters('app', ['getTheme'])
    },
    data () {
      return {
        snackbarConfig: {
          snackbar: false,
          color: 'info',
          mode: '',
          timeout: 6000,
          text: 'Erro de conexão com o servidor!'
        },
        healthInsurances: [],
        healthInsurance: '',
        valid: true,
        active: null,
        user: {
          id: '',
          name: '',
          username: '',
          password: '',
          passwordConfirm: '',
          enabled: true,
          customer: this.customer,
          customerName: '',
          type: 'Owner',
          cpf: '',
          birthDay: '',
          healthInsurance: '',
          phone: '',
          mobile: '',
          gender: 'M',
          numberMedicalRecord: '',
          clientId: ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/profile/index.vue